/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.0.1
 */

import produce from 'immer';
import { Reducer } from 'redux';

import {
    WIDGET_COSTS_LOAD_CHART,
    WIDGET_COSTS_LOAD_CHART_ERROR,
    WIDGET_COSTS_LOAD_CHART_SUCCESSFUL,
    WIDGET_COSTS_REDIRECT_TO_PAYMENTS_ERROR,
} from './constant/actionConstants';
import { widgetCostsInitialState } from './constant/widgetCostsConstants';
import { TWidgetCostsChartValue } from './types/widgetCostsType';
import { TWidgetCostsActions } from './widgetCostsActions';

export interface IWidgetCostsChart {
    [dateTo: string]: TWidgetCostsChartValue;
}

export interface IWidgetCostsReducer {
    charts: IWidgetCostsChart;
    currentDateTo: string;
    error: string;
    isLoading: boolean;
}

const widgetCostReducer: Reducer<IWidgetCostsReducer, TWidgetCostsActions> =
    (state = widgetCostsInitialState, action: TWidgetCostsActions) =>
        produce(state, draft => {
            switch (action.type) {
                case WIDGET_COSTS_LOAD_CHART:
                    draft.currentDateTo = action.payload.dateTo;
                    draft.error = widgetCostsInitialState.error;
                    draft.isLoading = true;
                    break;
                case WIDGET_COSTS_LOAD_CHART_SUCCESSFUL:
                    draft.charts[draft.currentDateTo] = action.payload.chart;
                    draft.isLoading = false;
                    break;
                case WIDGET_COSTS_LOAD_CHART_ERROR:
                    draft.isLoading = false;
                    draft.error = action.payload.error;
                    break;
                case WIDGET_COSTS_REDIRECT_TO_PAYMENTS_ERROR:
                    draft.error = action.payload;
                    break;
                default:
                    break;
            }
        });

export default widgetCostReducer;
